<custom-modal [header]="'COMPANY.IOR.CONFIRM_MATCH.HEADER'" [open]="open" (openChange)="decline.emit()">
  <div [innerHTML]="'COMPANY.IOR.CONFIRM_MATCH.BODY' | translate"></div>

  <button footer-action type="button" class="btn btn-secondary" (click)="decline.emit()">
    {{ "COMPANY.IOR.CONFIRM_MATCH.DECLINE" | translate }}
  </button>
  <button footer-action type="button" class="btn btn-primary ml-2" (click)="accept.emit()">
    {{ "COMPANY.IOR.CONFIRM_MATCH.ACCEPT" | translate }}
  </button>
</custom-modal>
